"use client";

import { Header } from "@/components/header";
import { Footer } from "@/components/footer";

export default function AppLayout({ children }: { children: React.ReactNode }) {
	return (
		<div className="flex flex-col">
			<Header />
			<main>{children}</main>
			<Footer />
		</div>
	);
}
